import React from "react";
import { Typography, useTheme } from "@mui/material";
import { extractWordsAndFragmentsFromHighlight } from "./utils";
import AcxChipList from "components/UI/AcxChipList";

interface HighlightItemProps {
    highlight: string;
    speaker: string;
    disableChips?: boolean;
}

function HighlightItem(props: HighlightItemProps) {
    const { fragments, words } = extractWordsAndFragmentsFromHighlight(
        props.highlight,
    );

    const theme = useTheme();

    return (
        <Typography>
            <Typography
                component="span"
                sx={{ fontWeight: 700, fontSize: "13px" }}
            >
                {props.speaker}:{" "}
            </Typography>
            <Typography
                component={"span"}
                sx={{
                    "& b": {
                        color: theme.palette.blue.main,
                        fontWeight: 600,
                    },
                }}
                className={"pendo-ignore"}
                style={{ fontWeight: 400 }}
                dangerouslySetInnerHTML={{
                    __html: fragments.join(" ... "),
                }}
            />
            {!props.disableChips && (
                <AcxChipList size="small" color="gray" values={words} />
            )}
        </Typography>
    );
}

export default HighlightItem;
